export interface CommunityBoardRevealResult {
    cards: string[];
    changed: boolean;
}

export interface CommunityBoardCardReveal {
    cardIndex: number;
    card: string;
}

export class PokerBoardPresentation {
    private visibleCommunityCards: string[];

    constructor(snapshotCards: readonly string[] = []) {
        this.visibleCommunityCards = [...snapshotCards];
    }

    public getVisibleCommunityCards = (): string[] => {
        return [...this.visibleCommunityCards];
    };

    public resetToSnapshot = (snapshotCards: readonly string[] = []): string[] | null => {
        const nextCards = [...snapshotCards];
        if (areSameCards(this.visibleCommunityCards, nextCards)) return null;

        this.visibleCommunityCards = nextCards;
        return this.getVisibleCommunityCards();
    };

    public resetToSnapshotCards = (snapshotCards: readonly string[] = []): string[] => {
        return this.resetToSnapshot(snapshotCards) || this.getVisibleCommunityCards();
    };

    public syncSnapshot = (snapshotCards: readonly string[] = []): string[] | null => {
        const nextSnapshotCards = [...snapshotCards];
        if (areSameCards(this.visibleCommunityCards, nextSnapshotCards)) return null;

        if (nextSnapshotCards.length <= this.visibleCommunityCards.length) {
            this.visibleCommunityCards = nextSnapshotCards;
            return this.getVisibleCommunityCards();
        }

        return null;
    };

    public revealCard = (cardReveal: CommunityBoardCardReveal): CommunityBoardRevealResult | null => {
        if (cardReveal.cardIndex < 0 || cardReveal.cardIndex > this.visibleCommunityCards.length) {
            return null;
        }

        const nextVisibleCards = [...this.visibleCommunityCards];
        nextVisibleCards[cardReveal.cardIndex] = cardReveal.card;
        const trimmedVisibleCards = nextVisibleCards.slice(0, cardReveal.cardIndex + 1);
        const changed = !areSameCards(this.visibleCommunityCards, trimmedVisibleCards);

        if (changed) {
            this.visibleCommunityCards = trimmedVisibleCards;
        }

        return {
            cards: this.getVisibleCommunityCards(),
            changed
        };
    };
}

const areSameCards = (left: readonly string[], right: readonly string[]): boolean => {
    return left.length === right.length && left.every((card, index) => card === right[index]);
};
